import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  SatModal,
  SatButton,
  SatInput,
  SatSelect,
} from '@components/common/satUI';

import * as eaAction from '@store/actions/eaAction';
import * as preUwAction from '@store/actions/preUwAction';
import * as customerAction from '@store/actions/customerAction';

// 고지입력 알림톡 URL 발송
const NtceAlarmTalkPopup = props => {
  const { visible, setVisible, insuredPrspInfo } = props;
  const { preUwMainInfo } = useSelector(state => state.preUwReducer);
  const dispatch = useDispatch();

  const [relationList, setRelationList] = useState([]);
  const [mobileTelNo, setMobileTelNo] = useState({
    label: '',
    value: '',
    cpNo: '',
    defaultValue: '',
  });

  useEffect(() => {
    if (visible && !$utils.isEmptyObject(insuredPrspInfo)) {
      if ($utils.checkMinor(insuredPrspInfo?.legalAge)) {
        // 미성년자일 경우 관계인 정보 조회
        dispatch(
          customerAction.searchCustomerRelationList({
            custNo: insuredPrspInfo.custNo,
            custKind: insuredPrspInfo.custKind,
            isAdultOnly: false,
            callback: ({ data }) => {
              const relationList = data
                .filter(item => item.adult)
                .map(item => ({
                  label: item.name,
                  value: item.custNo,
                  cpNo: item.cpNo,
                  defaultValue: item.cpNo,
                }));
              setRelationList(relationList);
              setMobileTelNo(relationList[0]);
            },
          }),
        );
      } else {
        setMobileTelNo({
          label: insuredPrspInfo.name,
          value: insuredPrspInfo.custNo,
          cpNo: insuredPrspInfo.mobileTelNo,
          defaultValue: insuredPrspInfo.mobileTelNo,
        });
      }
    }
  }, [visible, insuredPrspInfo]);

  // 알림톡 발송
  const handleSendClick = () => {
    dispatch(
      preUwAction.sendPreUwOmni({
        preUwMainInfo,
        mobileTelNo,
        callback: () => {
          setVisible(false);
          dispatch(eaAction.hidePreUwPopup());
          dispatch(eaAction.initEaState());
          dispatch(
            preUwAction.setPreUwMainInfo({
              beffatUndwNo: '',
              planEstablishNo: '',
            }),
          );
          $utils.sendMessageToParent({ type: 'closePopup' }, '*');
        },
      }),
    );
  };

  return (
    <SatModal
      visible={visible}
      setVisible={() => setVisible(false)}
      type="info"
      wide
    >
      <header className="modal-header">
        <h3 className="layer-tit2">고지입력 알림톡 URL 발송</h3>
      </header>
      <div className="cont">
        <div className="modal-scroll-wrap">
          <ul className="input-list-box">
            <li className="mgt-12">
              <SatInput
                type="text"
                readOnly
                noFocus
                label="대상고객"
                value={`${
                  insuredPrspInfo?.name
                } (${insuredPrspInfo?.rsdn?.substring(0, 6)}, ${
                  insuredPrspInfo?.genderLabel
                })`}
                border
              />
            </li>
            {$utils.checkMinor(insuredPrspInfo?.legalAge) && (
              <li className="mgt-12">
                <SatSelect
                  label="동의자"
                  options={relationList}
                  value={mobileTelNo.value}
                  onChange={option => {
                    setMobileTelNo(option);
                  }}
                />
              </li>
            )}
            <li className="mgt-12 mgb-16">
              <SatInput
                value={mobileTelNo.cpNo}
                type="number"
                label="휴대전화"
                maxLength={11}
                border
                useMobile
                onChange={value => {
                  setMobileTelNo(prev => ({
                    ...prev,
                    cpNo: value ? value : prev.defaultValue,
                  }));
                }}
              />
            </li>
          </ul>
          <div className="info-txt-bx">
            {$utils.checkMinor(insuredPrspInfo?.legalAge) && (
              <p className="notice-txt">
                ※ 미성년자의 경우 친권자가 정보제공에 동의합니다.
              </p>
            )}

            <p className="notice-txt">
              ※ 위 휴대전화로 고지입력 URL이 발송되니 전화번호가 정확한지 꼭
              확인 바랍니다.
            </p>
            <p className="notice-txt">
              ※ 발송된 URL은 발송일 21시 59분까지 작성 유효하며, 유효 작성
              시간이 경과한 경우 작성이 불가합니다.
            </p>
          </div>
        </div>
      </div>
      <div className="btn-wrap">
        <SatButton
          styleClass="btn btn-white"
          label="취소"
          onClick={() => {
            setVisible(false);
          }}
        />
        <SatButton
          styleClass="btn btn-yellow"
          label="발송"
          onClick={handleSendClick}
        />
      </div>
    </SatModal>
  );
};

export default NtceAlarmTalkPopup;
